import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../../components/tables/ReportsTable';

const AllTransactions = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const statuses = ['Success', 'Pending', 'Failed'];
    const types = ['Recharge', 'Bill Payment', 'Money Transfer', 'AEPS', 'DMT'];
    const operators = ['Airtel', 'Jio', 'VI', 'BSNL', 'Electricity', 'Gas', 'Water'];
    
    return Array.from({ length: count }, (_, i) => ({
      transactionId: `TXN${String(i + 1).padStart(6, '0')}`,
      date: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0],
      type: types[Math.floor(Math.random() * types.length)],
      operator: operators[Math.floor(Math.random() * operators.length)],
      mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      amount: (Math.random() * 5000 + 100).toFixed(2),
      status: statuses[Math.floor(Math.random() * statuses.length)],
      commission: (Math.random() * 50 + 5).toFixed(2),
      userId: `USER${String(Math.floor(Math.random() * 1000) + 1).padStart(4, '0')}`
    }));
  };

  const [data] = useState(generateSampleData(100));

  // Column definitions
  const columns = [
    { key: 'transactionId', label: 'Transaction ID' },
    { key: 'date', label: 'Date' },
    { key: 'type', label: 'Type' },
    { key: 'operator', label: 'Operator' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'amount', label: 'Amount' },
    { key: 'commission', label: 'Commission' },
    { key: 'status', label: 'Status' },
    { key: 'userId', label: 'User ID' }
  ];

  return (
    <Container fluid className="">
      <ReportsTable
        data={data}
        reportType="All_Transactions"
        columns={columns}
        title="All Transactions"
      />
    </Container>
  );
};

export default AllTransactions;

